import { render, staticRenderFns } from "./CatalogActions.vue?vue&type=template&id=2fae3e98"
import script from "./CatalogActions.vue?vue&type=script&lang=js"
export * from "./CatalogActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports